import React, { useEffect, useState } from 'react'
import '../../assets/css/home.css'
import Layout from '../../layout'
import TopBar from '../../components/TopBarNavigation'
import PatientCard from '../../components/PatientCard'
import { Row, Col, Tabs, Tab } from 'react-bootstrap';
import { useLocation, Link, useNavigate } from 'react-router-dom'
import SearchIcon from '../../assets/images/search.svg'
import CardEx1 from '../../assets/images/cardEX.png'
import CardEx2 from '../../assets/images/cardEX2.png'
import CardEx3 from '../../assets/images/cardEX3.png'
import CardEx4 from '../../assets/images/cardEX4.png'
import CardEx5 from '../../assets/images/cardEX5.png'
import CardEx6 from '../../assets/images/cardEX6.png'
import CardEx7 from '../../assets/images/cardEX7.png'
import CardEx8 from '../../assets/images/cardEX8.png'
import { UseEffectOnce } from '../../Hook/UseEffectOnce'
import { get, getAuthConfig } from '../../libs/http-hydrate'
import MyExerciseFill from "../../assets/images/My Exercise.svg"
import PublicLayout from '../../layout/PublicLayout'

const BodyPart = (props) => {
  const location = useLocation()
  const navigate = useNavigate()
  const [key, setKey] = useState('Custom');
  const [loading, setLoading] = useState(true);
  const [bodyPartData, setBodyPart] = useState(
    {
      has_more: false,
      items: [],
    });
  const [page, setPage] = useState(0);
  let controller = null; // Store the AbortController outside the function

  useEffect(() => {
    setBodyPart({ has_more: false, items: [] }); // Clear previous data
    setPage(0);
    getBodyPartData();
    setLoading(true);

    // Cleanup: Cancel the pending API call when the component unmounts or key changes
    return () => {
      if (controller) {
        controller.abort();
      }
    };
  }, [key]);
  async function getBodyPartData() {
    setLoading(true);
      if (controller) {
      controller.abort();
    }
  
    // Create a new AbortController
    controller = new AbortController();
    const signal = controller.signal;
  
    try {
      let url ;
      if(key === "General"){
        url = `/bodyPartList?pageNumber=${page}&isTemplate=true`
      }
      else{
        url = `/bodyPartList?pageNumber=${page}`
      }
      const data = await get(url, {headers: {
        'Content-Type': 'application/json'
      },
      signal});
      if (data?.status === 200) {
        let items = data?.data?.data;
        if (key === "Custom") {
          // Add 'MyExercise' to the items array when key is 'Custom'
          items = [...items, { _id: 'myExercise', title: 'My Exercise', image: MyExerciseFill}];
        }
        setBodyPart((p) => ({ ...p, items, has_more: data?.data?.has_more }));
      }
      setLoading(false); // Ensure loader is shown again when API is aborted

    } catch (error) {
      if (error.name === "AbortError") {
        console.log("Previous API call aborted");
        setLoading(true); // Ensure loader is shown again when API is aborted
      } else if (error?.response?.status === 401) {
        navigate("/login");
      }
    }
  }

  return (
    <PublicLayout>
      <div style={{padding:"30px"}}>
      {key === "Custom" ? 
       <div className="py-3" style={{backgroundColor:"#FFF7F5",  border: "1px solid #F9CABE",borderRadius:"12px"}}>
    {/* Heading */}
    <h5 className="my-2 text-center text-xl font-semibold text-orange-600 md:text-2xl" style={{color:"#FF6036"}}>
      Exercise Library&nbsp;: Physiotherapy Workouts&nbsp;&amp;&nbsp;Recovery&nbsp;Tools
    </h5>

    {/* Body copy */}
    <p className="text-center text-sm px-5 leading-relaxed text-gray-700 md:text-base" style={{fontSize:"14px"}}>
      Discover our easy-to-use Home Exercise Library, built by physiotherapists to support
      your recovery every step of the way. From injury rehab to everyday mobility,
      explore clear, effective routines you can do at home – whenever it works for you.
      <br className="hidden sm:block" />
      Simple. Trusted. Made to move with you.
    </p>
  </div> : <div className="py-3" style={{backgroundColor:"#FFF7F5",  border: "1px solid #F9CABE",borderRadius:"12px"}}>
    {/* Heading */}
    <h5 className="my-2 text-center text-xl font-semibold text-orange-600 md:text-2xl" style={{color:"#FF6036"}}>
    Rehabilitation Protocols That Drive Results    </h5>

    {/* Body copy */}
    <p className="text-center text-sm px-5 leading-relaxed text-gray-700 md:text-base" style={{fontSize:"14px"}}>
    Our easy-to-follow rehab protocols guide you through every step of your recovery journey. Designed by experts, these plans help you know exactly what to do and when - making healing less confusing and more effective. Whether you're recovering from an injury or working to stay strong, these protocols give you the support you need to get moving again with confidence.
    </p>
  </div> }</div>
      <TopBar title={"Library"} tab={"Physiotherapist"} tabChild={"Library"} />


      <div className='main-content-part' >
        <div className='exercise-tab-part'>

          <Tabs
            id="controlled-tab-example"
            activeKey={key}
            onSelect={(k) => { setKey(k) }}
            className="mb-3 mt-0  d-flex justify-content-center"
          >
               <Tab eventKey="Custom" title="Exercise">
            </Tab>
            <Tab eventKey="General" title="Protocol">
            </Tab>
         

          </Tabs>
        </div>
        <Row className='g-4'>

        {loading && page === 0 ?  (
                <div className="preloader-whirlpool text-center align-items-center">
                    <div className="whirlpool"></div>
                </div>
            ) : ( <>
          {bodyPartData?.items && bodyPartData?.items.length > 0 &&

            bodyPartData?.items.map((item, index) => {
              return (
                <>
                  <Col xl="3" lg="4" md="6" sm="12" key={`${item._id}-${index}`}>
                    <Link 
                    
                    to={key === "Custom" ? "/exercise-list" : "/protocol-list"}
                    state={{
                      routine: location?.state?.routine,
                      patient_id: location?.state?.patient_id,
                      patientDetail: location?.state?.patientDetail,
                      ...(item._id !== 'myExercise' && { bodypartId: item._id }), // Conditionally include bodypartId
                      bodyPart: item?.title,
                      bodyPartImage: item?.image,
                      workout: location?.state?.workout,
                      cart: location?.state?.cart,
                      ...(item._id == 'myExercise' && { myExercise: "myExercise" }), // Conditionally include bodypartId
                    }}
                    >
                      <div className='ex-card'>
                        <div className='ex-image'>
                          <img src={item?.image} alt='CardEx1' height={130} />
                        </div>
                        <h6 className='title'>{item?.title}</h6>
                      </div>
                    </Link>
                  </Col>
                </>
              )
            })
          }
          </>)}
          {loading && page > 0 && (
                    <div className="text-center">
                        <div className="whirlpool"></div>
                    </div>
                )}
        </Row>
      </div>
    </PublicLayout>
  )
}

export default BodyPart
